import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import { de } from '@/i18n/locales/de';
import { el } from '@/i18n/locales/el';
import { en } from '@/i18n/locales/en';
import { es } from '@/i18n/locales/es';
import { fr } from '@/i18n/locales/fr';
import { it } from '@/i18n/locales/it';
import { nl } from '@/i18n/locales/nl';
import { pt } from '@/i18n/locales/pt';
import { tr } from '@/i18n/locales/tr';

export const resources = {
  en: { translation: en },
  nl: { translation: nl },
  de: { translation: de },
  fr: { translation: fr },
  es: { translation: es },
  el: { translation: el },
  it: { translation: it },
  pt: { translation: pt },
  tr: { translation: tr },
} as const;

// No React provider needed: `initReactI18next` registers the instance
// globally, so `useTranslation()` works everywhere — including
// `RequireAuth`/`AuthScreen`/`MeProvider`, which render outside `MeContext`
// (src/app/routes.tsx), and in tests that render `AppRoutes` directly.
void i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'nl', 'de', 'fr', 'es', 'el', 'it', 'pt', 'tr'],
    detection: {
      order: ['querystring', 'localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    interpolation: {
      // React already escapes interpolated values.
      escapeValue: false,
    },
  });

export default i18next;
